import { HiringCompanies } from '@components/local';
import { getStrapiURL, COMPILATION_BASE_URL } from '@lib/api';
import PressHighlights from '@components/shared/PressHighlights';
import axios from 'axios';
import JoinSuccessStory from './JoinSuccessStory';
import hiredSection from './PlacementCarousel';
import PlacementCarousel from './PlacementCarousel';
import HiringSteps from './HiringSteps';
import CareertrackPage from './CareertrackPage';
import Faq from './Faq';
import Testimonials from './Testimonials';
import VideosCarousel from './VideosCarousel';
import StudentPlacementChart from './StudentPlacementChart';
import EllipticalSegmentChart from './EllipticalSegmentChart';
import { RecruiterTestimonials } from '@components/local/hire-from-us';
const apiBaseUrl = getStrapiURL();
const compilationBaseUrl = COMPILATION_BASE_URL;
export default function PlacementDevelop({
  newHiring = true,
  pressHighlights,
  hiringPartnersList,
  hireData,
  faqData,
  placementPageData,
  hereStudentsData,
  heroSectionStats,
  nonHeroStudentsData,
  placementStats,
  recruiterTestimonials,
  videosData
}) {
  console.log(placementStats?.SalaryBreakup, 'placementStats');

  const demoSegments = [
    { label: '> 8 LPA', percentage: 46 },
    { label: '3 - 5 LPA', percentage: 24 },
    { label: '< 3 LPA', percentage: 2 },
    { label: '5 - 8 LPA', percentage: 28 },
  ];

  const segmentData = placementStats?.SalaryBreakup
  
  const bracketOrder = ['> 8', '3-5', '< 3', '5-8'];
  
  const labelMap = {
    '> 8': '> 8 LPA',
    '3-5': '3 - 5 LPA',
    '< 3': '< 3 LPA',
    '5-8': '5 - 8 LPA'
  };
  
  const orderedSegments = bracketOrder?.map((bracket) => {
    const entry = segmentData?.find(item => item?.SalaryBracket === bracket);
    return {
      label: labelMap[bracket],
      percentage: entry ? Number(entry.Percentage) : 0
    };
  });
  console.log(orderedSegments, 'orderedSegments');

  return (
    <>
      <JoinSuccessStory hereStudentsData={hereStudentsData} heroSectionStats={heroSectionStats} />

      <HiringCompanies
        placementPage={true}
        newHiring
        hiringPartners={hiringPartnersList}
        heading={"We've Trusted Companies as Our"}
        highlightedText={'Hiring Partners'}
      />

      <PlacementCarousel placementPage={true} nonHeroStudentsData = {nonHeroStudentsData} />
      <HiringSteps placementPage={true} />
      <StudentPlacementChart
        placementPage={true}
        segments={orderedSegments}
        year={2024}
        subtitle="% Students Placed in"

      />
      <VideosCarousel placementPage={true} placementStats={placementStats} videosData = {videosData} />
      <Testimonials placementPage={true} recruiterTestimonials = {recruiterTestimonials} />
      <CareertrackPage />
      <Faq placementPage={true} faqData={faqData} />
    </>
  );
}

export async function getStaticProps(context) {
  try {
    const { data: pressHighlights } = await axios.get(
      `${apiBaseUrl}/api/press-hightlight?populate=highlights.image`
    );
    const { data: hiringPartners } = await axios.get(
      `${apiBaseUrl}/api/hiring-partner?populate=partners.images`
    );
    const { data: hire } = await axios.get(`${apiBaseUrl}/api/hire?populate=seo.image`);

    const { data: faqData } = await axios.get(`${compilationBaseUrl}/api/website/faq`);

    const { data: placementPageData } = await axios.get(
      `${compilationBaseUrl}/api/website/placement-data`
    );

    // console.log(placementPageData, 'faqDataaa');
    // console.log(hiringPartners, 'hiringPartnersList');
    // console.log(pressHighlights, 'pressHighlights');
    return {
      props: {
        pressHighlights: pressHighlights.data || {},
        hiringPartnersList: hiringPartners.data.attributes.partners || [],
        hireData: hire.data.attributes,
        // testimonials: testimonials.data,
        faqData: faqData?.data?.attributes?.Faq || [],
        hereStudentsData: placementPageData?.data?.attributes?.SuccessStories?.heroStudents || [],
        nonHeroStudentsData:
          placementPageData?.data?.attributes?.SuccessStories?.nonHeroStudents || [],
        heroSectionStats: placementPageData?.data?.attributes || {},
        placementStats: placementPageData?.data?.attributes?.Stats || [],
        recruiterTestimonials: placementPageData?.data?.attributes?.Recruites || [],
        videosData: placementPageData?.data?.attributes?.SuccessStories || [],


      },
      revalidate: 3600,
    };
  } catch (error) {
    console.error('Error fetching data:', error.message);
    return { props: { error: error.message } };
  }
}
